module.exports = __webpack_public_path__ + "static/media/Wolfram.97b22f71.svg";